<template>
    <div class="bb-contacts-tracking-list">
      <transition name="fade" appear>
        <loader-fly v-if="loaderRun"/>
      </transition>
      <div class="bb-contacts-tracking-list-header">
        <div class="bb-contacts-tracking-list-header__item"
             :class="{'bb-contacts-tracking-list-header__item_active': activeTab === tab.id}"
             @click="goTable(tab)"
             v-for="tab in tabs"
             :key="tab.id">
          {{tab.title}}
        </div>
      </div>
      <div class="bb-contacts-tracking-list-header-options">
        <div class="bb-tabs" v-if="!isBirthdays">
          <div class="bb-tabs__item bb-contacts-tracking-list-header-options__tab"
               v-for="status in statuses"
               :key="status.title"
               @click="setStatus(status)"
               :class="{'bb-tabs__item_active' : activeStatus.title === status.title}">
            {{altTitleStatus ? status.altTitle || status.title : status.title}}
          </div>
        </div>
        <div class="bb-contacts-tracking-list-filter">
          <BBSearch
            class="bb-contacts-tracking-list__search"
            :valueSearch.sync="valueSearch"
          />
          <FilterByDate
            v-show="activeTab !== 6"
            @setDate="setFilterDate"
            position="left"
            all-name="All"
            :border="true"
            :future="true"
          />
          <div>
            <button class="bb-contacts-tracking-list-filter__button bb-button"
                    @click="sendEmail"
                    v-if="accessMassMailing">
              send email
            </button>
          </div>
        </div>
      </div>
      <VuePerfectScrollbar class="bb-contacts-tracking-list-body" @ps-scroll-y="scrollTable">
        <transition name="routing-fade" appear>
          <router-view
            :filterByDate="filterByDate"
            :scroll="eventScroll"
            :status="activeStatus"
            :valueSearch="valueSearch"
            @loader="setLoader"
          />
        </transition>
      </VuePerfectScrollbar>
      <div class="bb-contacts-tracking-list__bottom-margin"></div>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import FilterByDate from '@/components/Main/FilterByDate/FilterByDate'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import BBSearch from '@/components/Main/BBSearch/BBSearch'
import {find, get} from 'lodash'
import {FOUNDER} from '@/constants/roles'

export default {
  name: 'ContactsTrackingLists',
  components: {
    BBSearch,
    VuePerfectScrollbar,
    FilterByDate,
    LoaderFly
  },
  data () {
    return {
      loaderRun: false,
      eventScroll: 0,
      filterByDate: '',
      activeTab: 1,
      activeStatus: {},
      statuses: [
        {
          title: 'actual',
          statusKeys: [1, 2, 3]
        },
        {
          title: 'expired',
          statusKeys: [4]
        },
        {
          title: 'liquidated',
          altTitle: 'cancelled',
          statusKeys: [5]
        }
      ],
      tabs: [
        {id: 1, title: 'License Expiry', route: 'ContactsTrackingLicense'},
        {id: 2, title: 'Establishment Card Expiry', route: 'ContactsTrackingCard'},
        {id: 3, title: 'E-channel Expiry', route: 'ContactsTrackingEchannel'},
        {id: 4, title: 'Visa Expiry', route: 'ContactsTrackingVisa'},
        {id: 5, title: 'Office Lease Expiry', route: 'ContactsTrackingOffice'},
        {id: 7, title: 'Apartment Lease Expiry', route: 'ContactsTrackingApartment'},
        {id: 6, title: 'Birthdays', route: 'ContactsTrackingBirthdays'}
      ],
      valueSearch: ''
    }
  },
  computed: {
    isBirthdays () {
      return this.activeTab === 6
    },
    altTitleStatus () {
      return [4, 5, 7].includes(this.activeTab)
    },
    accessMassMailing () {
      const userInfo = this.$store.getters.userInfo
      const isFounder = userInfo.role === FOUNDER.id
      return isFounder || get(userInfo, 'massMailingCheck', '')
    },
    emailStore: {
      get: function () {
        return this.$store.getters.emailStore
      },
      set: function (data) {
        this.$store.dispatch('setEmailStore', data)
      }
    },
    sendMail: {
      get: function () {
        return this.$store.getters.sendMail
      },
      set: function (data) {
        this.$store.dispatch('setSendMail', data)
      }
    }
  },
  methods: {
    setLoader (value) {
      this.loaderRun = value
    },
    scrollTable (e) {
      this.eventScroll = e
    },
    goTable (tab) {
      this.activeTab = tab.id
      this.$router.push({name: tab.route})
    },
    setStatus (status) {
      this.activeStatus = status
      this.$router.replace({ query: { status: status.title } })
    },
    setFilterDate (range) {
      this.filterByDate = range
    },
    sendEmail () {
      if (this.emailStore.length > 0) {
        this.$router.push({name: 'MainPageEmail', params: {massMailing: true}})
      }
      this.sendMail = true
    },
    checkActiveTab () {
      const currentTab = find(this.tabs, {route: this.$route.name}) || this.tabs[0]
      this.activeTab = currentTab.id
    },
    checkActiveStatus () {
      this.activeStatus = find(this.statuses, {title: this.$route.query.status}) || this.statuses[0]
    }
  },
  watch: {
    $route () {
      this.checkActiveTab()
      this.checkActiveStatus()
    }
  },
  beforeMount () {
    this.checkActiveTab()
    this.checkActiveStatus()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../sass/variables";
  @import "../../../../../sass/mixins";

  .bb-contacts-tracking-list {
    @include global-font;
    display: grid;
    grid-template-rows: auto 58px 1fr;
    margin: -10px -20px;
    background: $color-white;
    border-radius: 6px;
    height: calc(100vh - 60px);

    &-header {
      display: flex;
      justify-content: space-between;
      border-bottom: 6px solid $color-wild-sand;

      &__item {
        position: relative;
        padding: 18px 25px;
        font-weight: 600;
        font-size: 15px;
        color: $color-accent;
        transition: 0.3s;
        cursor: pointer;

        &:after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 0;
          opacity: 0;
          background: $color-accent;
          border-radius: 3px 4px 0 0;
          transition: 0.3s;
        }

        &:hover {
          &:after {
            height: 3px;
            opacity: 1;
            background-color: $color-accent-hover;
          }
        }

        &_active {
          pointer-events: none;

          &:after {
            height: 3px;
            opacity: 1;
          }
        }
      }

      &-options {
        display: flex;
        align-items: center;
        justify-content: space-between;

        &__tab {
          text-transform: capitalize;
          max-height: 58px;
          border-radius: 0;
        }
      }
    }

    &-filter {
      display: flex;
      justify-content: center;
      align-items: center;
      grid-gap: 0 10px;
      margin-top: 16px;
      margin-right: 0;
      margin-left: auto;
      padding: 0 25px;

      &__button {
        min-width: 120px;
        text-transform: uppercase;
        padding: 13px 23px;
      }
    }

    &-body {
      height: 100%;
      padding: 0 25px;
      margin-bottom: 25px;
    }

    &__bottom-margin {
      position: sticky;
      bottom: 0;
      background-color: $color-white;
      width: 100%;
      height: 25px;
    }

    &__search {
      width: 257px;

      @media (max-width: 1440px) {
        width: 100%;
        min-width: 220px;
      }
    }

    .bb-tabs {

      &__item {
        @media (max-width: 1440px) {
          min-width: 140px;
        }
      }
    }
  }
</style>

<style lang="scss">

  .bb-contacts-tracking-list {

    .bb-date-filter__date {
      @media (max-width: 1440px) {
        min-width: 120px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactsTrackingLists/ContactsTrackingLists.vue